import { render, staticRenderFns } from "./CentralBotHighlight.vue?vue&type=template&id=46513f22&scoped=true"
import script from "./CentralBotHighlight.vue?vue&type=script&lang=js"
export * from "./CentralBotHighlight.vue?vue&type=script&lang=js"
import style0 from "./CentralBotHighlight.vue?vue&type=style&index=0&id=46513f22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46513f22",
  null
  
)

export default component.exports